/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { injectable } from 'inversify';
import { ApplicationDetailPageAgent, getAgent } from './agent';
import { logger as log } from '../../../common/logger';
const is = require('is_js');

const SERVICE_NAME = 'ApplicationDetailPageService';

@injectable()
export class ApplicationDetailPageService {
  private static instance: ApplicationDetailPageService;
  public agent: ApplicationDetailPageAgent;
  static displayName = 'ApplicationDetailPageService';

  constructor(props: any = {}) {
    this.agent = getAgent();
  }
}
